<app-loader *ngIf="isLoading"></app-loader>
<form method="post" *ngIf="!isLoading" [formGroup]="subjectForm">
  <div class="col-6">
    <div class="form-group">
      <label>Név</label>
      <input readonly id="name" type="text" class="form-control" formControlName="name" />
    </div>

    <div class="form-group">
      <label>Leírás</label>
      <textarea rows="3" readonly id="description"class="form-control" formControlName="description"></textarea>
    </div>

    <div class="form-group">
      <label>Javasolt bruttó időkeret (perc)<span class="required-label" *ngIf="defaultGrossTimeLimitMinutes.errors?.['required']">*</span></label>
      <input id="defaultGrossTimeLimitMinutes" type="number" class="form-control" formControlName="defaultGrossTimeLimitMinutes" />
    </div>
    <div *ngIf="defaultGrossTimeLimitMinutes.invalid && (defaultGrossTimeLimitMinutes.dirty || defaultGrossTimeLimitMinutes.touched)" class="alert alert-danger">
      <div *ngIf="defaultGrossTimeLimitMinutes.errors?.['required']">Javasolt bruttó időkeret megadása kötelező.</div>
      <div *ngIf="defaultGrossTimeLimitMinutes.errors?.['min']">Negatív érték nem adható meg.</div>
    </div>
  </div>

  <div class="button-group">
    <button (click)="onSubmit()" class="btn btn-primary text-white btn-save me-2" [disabled]="subjectForm.invalid">
      Mentés
    </button>
    <a
      (click)="onGoBack('/subjects')"
      class="btn btn-dark">
      Vissza
    </a>
  </div>
</form>
